export interface TreatmentClearAligner {
    treatmentId: string;
    patientAge: number;
    clearAlignerType: number;
    chiefComplaint?: string;
    clinicalCondition?: number[];
    clinicalConditionNotes?: string;
    teethNotToMove?: number[];
    midlines: number;
    midlineNotes: string;
    overjet: number;
    overbite: number;
    toothSizeDiscrepancy: number;
    attachments: number;
    attachmentsTeethNotes?: number[];
    ipr: number;
    iprTeethNotes?: number[];
    anteriorCanineRelationshipRight: number;
    anteriorCanineRelationshipLeft: number;
}

export interface ClearAlignerDetailItem {
    order: number;
    key: string;
    value: string;
}

export type ClearAlignerDetails = ClearAlignerDetailItem[];
